import { apiRequest } from "./client";

/** DELETE /v1/account (firm-model spec §5.4). Throws ApiError `sole_admin` when the
 * firm still has members and no other admin. */
export async function deleteMyAccount(): Promise<void> {
  await apiRequest("/v1/account", { method: "DELETE" });
}
